import styled from 'styled-components';

const SubTitle = styled.h2`
    font-size: 1.05em;
    margin-top: 5px;
`;

export default SubTitle;
